import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { EssClientLogger } from 'typeahead-client-logger';
import { Location } from './location';
import { SearchFormFieldProps } from 'components/common/search-form';

interface LocationWrapperProps extends SearchFormFieldProps {
  essAnalyticsLogger?: EssClientLogger;
}

export class LocationWrapper extends React.Component<LocationWrapperProps> {
  render() {
    return (
      <Experiment name="Optimize_Number_Of_Typeahead_Suggestion">
        <ExperimentControl>
          <Location {...this.props} maxTypeaheadResults={10} />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <Location {...this.props} maxTypeaheadResults={5} />
        </ExperimentVariant>
        <ExperimentVariant bucket={2}>
          <Location {...this.props} maxTypeaheadResults={6} />
        </ExperimentVariant>
      </Experiment>
    );
  }
}
